import { useTranslation } from 'react-i18next'

export const useInvoiceBillsLabelsMap = () => {
    const { t } = useTranslation('translations')

    return {
        usn: t('invoice_table.usn'),
        usnAccountName: t('invoice_table.usnAccountName'),
        meters: t('invoice_table.meters'),
        startDate: t('invoice_table.startDate'),
        endDate: t('invoice_table.endDate'),
        commodity: t('invoice_table.commodity'),
        usage: t('invoice_table.usage'),
        amount: t('invoice_table.amount'),
        notesCount: t('invoice_table.notesCount'),
    }
}

export type InvoiceBillsLabelsMap = {
    usn: string
    usnAccountName: string
    meters: string
    startDate: string
    endDate: string
    commodity: string
    usage: string
    amount: string
    notesCount: string
}
